import { render, staticRenderFns } from "./ViewButton.vue?vue&type=template&id=312a75e1&scoped=true&lang=pug&"
import script from "./ViewButton.vue?vue&type=script&lang=js&"
export * from "./ViewButton.vue?vue&type=script&lang=js&"
import style0 from "./ViewButton.vue?vue&type=style&index=0&id=312a75e1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312a75e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('312a75e1')) {
      api.createRecord('312a75e1', component.options)
    } else {
      api.reload('312a75e1', component.options)
    }
    module.hot.accept("./ViewButton.vue?vue&type=template&id=312a75e1&scoped=true&lang=pug&", function () {
      api.rerender('312a75e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/ViewButton.vue"
export default component.exports